export default "__VITE_ASSET__DPN4sfQN__"